import Anchor from '@oneflare/flarekit/lib/components/Anchor';
import H1 from '@oneflare/flarekit/lib/components/H1';
import H2 from '@oneflare/flarekit/lib/components/H2';
import RightChevron from '@oneflare/flarekit/lib/components/icons/RightChevron';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled, css } from 'styled-components';

import Breadcrumbs from 'shared/components/Breadcrumbs';
import wysiwygStyles from 'shared/styles/wysiwyg';

export const ArticleContentStyled = styled.div`
  ${wysiwygStyles}
`;

export const WinWorkGuidesStyled = styled.div`
  min-width: 100%;

  ${media.mdUp`
    position: sticky;
    top: 92px;
    width: 300px;
    min-width: 240px;
  `}
`;

export const WinWorkTitle = styled(H2)`
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 22px;
  line-height: 1.5;
  margin: 0;
`;

export const GuideListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const GuideListItemStyled = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.color.cloud};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const GuideHeaderStyled = styled(H1)`
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 22px;
  line-height: 1.5;
  margin: 0 0 16px;

  ${media.lgUp`
    max-width: 645px;
    font-size: 40px;
  `}
`;

export const GuideTitleStyled = styled(Anchor)`
  color: ${({ theme }) => theme.color.gunMetal};
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.primaryRegular};
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  position: relative;
  padding: 16px 24px 16px 0;
  width: 100%;

  &:hover {
    color: ${({ theme }) => theme.color.primary};
    text-decoration: none;

    svg {
      fill: ${({ theme }) => theme.color.primary};
      stroke: ${({ theme }) => theme.color.primary};
      stroke-width: 3px;
    }
  }

  &:last-child {
    border: none;
  }

  ${({ isCurrentPage }) => (isCurrentPage && css`
    font-weight: bold;
  `)};
`;

export const GuideWrapperStyled = styled.section`
  max-width: 1200px;
  margin: 40px 20px 80px;

  ${media.mdUp`
    margin: 40px 40px 80px;
  `}

  ${media.lgUp`
    margin: 40px auto 80px;
    padding: 0 40px;
  `}
`;

export const GuideContentWrapperStyled = styled.div`
  ${media.mdUp`
    display: flex;
    align-items: start;
    flex-direction: row-reverse;
  `}
`;

export const GuideStyled = styled.section`
  width: 100%;

  ${media.mdUp`
    max-width: 100%;
    margin: 0 0 0 80px;
  `}

  ${media.lgUp`
    max-width: 645px;
    margin: 0 0 0 135px;
  `}
`;

export const RightChevronStyled = styled(RightChevron).attrs(({ theme }) => ({
  fill: theme.color.gunMetal,
  width: 12,
  height: 12,
  strokeWidth: 4
}))``;

export const FooterNavigationStyled = styled.div`
  border-top: 2px solid ${({ theme }) => theme.color.cloud};
  padding: 56px 0 0;
  margin: 56px 0 0;
  display: flex;
  justify-content: space-between;
`;

export const FooterNavigationTitle = styled.div`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.silver};
  font-size: 12px;
  line-height: 1.5;
  margin: 0 0 4px;
`;

export const FooterNavigationGuideLink = styled(Anchor)`
  font-size: 16px;
  line-height: 1.5;
`;

export const FooterNavigationNextStyled = styled.div`
  text-align: right;
  flex-grow: 1;
  flex-basis: 0;
  margin: 0 0 0 8px;
`;

export const FooterNavigationPrevStyled = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  margin: 0 8px 0 0;
`;

export const BreadcrumbsStyled = styled(Breadcrumbs).attrs(() => ({
  kind: 'category'
}))`
  text-align: left;
  display: block;
  padding: 0;
  margin: 0 0 24px;
`;
